export default __webpack_public_path__ + "static/media/logo.aa4ee68f.webp";